const state = {
    modalsOpen: [],
}

const mutations = {
    REGISTER_MODAL(state, data) {
        if (!state.modalsOpen.filter((modal) => modal.name === data.name).length)
            state.modalsOpen.push(data)
    },
    REFRESH_MODAL(state, data) {
        const index = state.modalsOpen.findIndex((modal) => modal.name === data.name)
        if (index > -1) state.modalsOpen[index].closable = data.closable
    },
    UNREGISTER_MODAL(state, data) {
        if (state.modalsOpen.filter((modal) => modal.name === data).length) {
            state.modalsOpen.splice(
                state.modalsOpen.findIndex((modal) => modal.name === data),
                1
            )
        }
    },
}

const actions = {
    modalOpen({ commit, state, dispatch }, data) {
        commit('REGISTER_MODAL', data)
        if (state.modalsOpen.length === 1) dispatch('openOverlayModal')
        if (state.modalsOpen.length)
            commit('BLOCK_OVERLAY', Boolean(state.modalsOpen.find((modal) => !modal.closable)))
    },

    modalRefresh({ commit, state, dispatch }, data) {
        commit('REFRESH_MODAL', data)
        if (state.modalsOpen.length === 1) dispatch('openOverlayModal')
        if (state.modalsOpen.length)
            commit('BLOCK_OVERLAY', Boolean(state.modalsOpen.find((modal) => !modal.closable)))
    },

    modalClose({ commit, state, getters, dispatch }, data) {
        commit('UNREGISTER_MODAL', data)
        if (state.modalsOpen.length) {
            commit('BLOCK_OVERLAY', Boolean(state.modalsOpen.find((modal) => !modal.closable)))
        } else if (getters.overlayModal) {
            commit('BLOCK_OVERLAY', false)
            dispatch('closeOverlayModal')
        }
    },
}

const getters = {
    modalsOpen: (state) => state.modalsOpen,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
